import styled from 'styled-components';
import { theme } from '@/components/features/theme/theme';

export const StyledBannerAds = styled.section`
    position: relative;
    border-radius: 4px 0px 0px 4px;
    background-image: url("/images/static/background.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding: 100px;

    .bannerAds {
        display: block;
    }

    h2 {
        color: ${theme.colors.white};
        font-size: 7.5rem;
        font-style: normal;
        font-weight: 400;
        line-height: 6.25rem;
        letter-spacing: -0.375rem;
    }

    p {
        color: ${theme.colors.white};
        font-size: 1.5rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.75rem;
        letter-spacing: 0;
    }

    @media (max-width: 1366px) {
        .col-md-7 {
            max-width: 80%;
            width: 80%;
        }
    }

    @media (max-width: 992px) {
        padding: 70px;

        h2 {
            color: ${theme.colors.white};
            font-size: 6.5rem;
            font-style: normal;
            font-weight: 400;
            line-height: 5.25rem;
            letter-spacing: -0.375rem;
        }
    }

    @media (max-width: 767px) {
        margin: 0 !important;
        padding: 120px 0;

        h2 {
            color: ${theme.colors.white};
            font-size: 3.25rem;
            font-style: normal;
            font-weight: 400;
            line-height: 3.25rem;
            letter-spacing: -0.1625rem;
        }
    }
`;
